import { getLogicData } from '@aytm/app/stats/lib/query/refs'
import { parseSavedPatterns } from '@aytm/app/stats/page/question-views/vq/lib/parse-saved-patterns'

// A parse error the row itself would still read tags from: an unresolved question or cluster name
// leaves the rest of the expression usable.
const isHardError = ({ text, result }) =>
  0 < text.length &&
  0 < result.expression.status.errors.length &&
  result.expression.status.errors.some(v => !['ref', 'cluster'].includes(v.type))

// A Matrix row takes a sub-question, so any error in it is one.
const isMatrixError = ({ text, result }) => 0 < text.length && 0 < result.expression.status.errors.length

// The codebooks and tags a Virtual question uses, keyed as its editor reports them (`pattern` for the
// question-level expression, `items.a<n>.pattern` / `.base` per answer). Read off the saved patterns
// with the same parse the rows run, so a question whose editor is folded away, and its rows unmounted,
// still tells the report which codes it depends on. A caller that also needs the dependency list hands
// in the parse it already made.
export const calcLogicData = ({ parsed, variant, tags, codeBooks, ...args }) => {
  const { answers, question } = parsed || parseSavedPatterns({ variant, ...args })
  const read = (parse, hardError) => getLogicData(tags, codeBooks, parse.result, hardError(parse))

  const items = {}
  answers.forEach(({ pattern, base }, index) => {
    const logic = { pattern: read(pattern, 'mx' === variant ? isMatrixError : isHardError) }
    if (base) logic.base = read(base, isHardError)
    items[`a${index + 1}`] = logic
  })

  return {
    pattern: question ? read(question, isHardError) : { codebook: [], tag: [] },
    items
  }
}
